import React from "react";
import useResponsive from "../../core/hooks/useResponsive";
import { TwoColumn, TwoRow } from "../../core/layouts";
import Styles from "./ListingHeaderLayout.module.scss";

const ListingHeaderLayout = ({ firstSection, secondSection }) => {
  const responsive = useResponsive();
  return responsive?.isSm ? (
    <TwoColumn
      className={Styles["main-container"]}
      leftSection={firstSection}
      rightSection={secondSection}
    />
  ) : (
    <TwoRow
      className={Styles["main-container-mobile"]}
      topSection={firstSection}
      bottomSection={secondSection}
    />
  );
};

export default ListingHeaderLayout;
